import { t } from 'i18next';
import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
const PdfViewerModal = ({ toggleModal, pdfBase64, visible }) => {
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };
  function changePage(offSet) {
    setPageNumber((prevPageNumber) => prevPageNumber + offSet);
  }

  function changePageBack() {
    changePage(-1);
  }

  function changePageNext() {
    changePage(+1);
  }

  return (
    <>
      <div className="App fixed inset-0   flex justify-center items-center z-50 bg-gray-600 bg-opacity-50">
        <div className="bg-green-50 px-2  rounded-lg w-full max-w-screen-lg md:max-w-screen-md sm:max-w-screen-sm">
          <button
            className=" flex justify-end mt-2  text-gray-500 font-bold text-3xl sm:text-xl"
            onClick={toggleModal}
            type="button"
          >
            x
          </button>
          <div className="pb-3">
            <center>
              <div>
                {visible ? (
                  <header className="App-header">
                    <Document file={`${pdfBase64}`} onLoadSuccess={onDocumentLoadSuccess}>
                      <Page height={window.innerWidth < 768 ? 300 : 600} pageNumber={pageNumber} />
                    </Document>
                  </header>
                ) : (
                  <header className="App-header">
                    <Document file={`data:application/pdf;base64,${pdfBase64}`} onLoadSuccess={onDocumentLoadSuccess}>
                      <Page
                        width={window.innerWidth < 768 ? 300 : 400}
                        height={window.innerHeight < 768 ? 300 : 300}
                        pageNumber={pageNumber}
                      />
                    </Document>
                  </header>
                )}
              </div>
              <p>
                {' '}
                Page {pageNumber} of {numPages}
              </p>
              <div className="flex justify-center">
                {pageNumber > 1 && (
                  <button
                    className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4
                    focus:ring-customgreen font-medium rounded-xl text-sm w-20 py-2.5 text-center me-1"
                    onClick={changePageBack}
                    type="button"
                  >
                    {t('Previous')}
                  </button>
                )}
                {pageNumber < numPages && (
                  <button
                    className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4
                    focus:ring-customgreen font-medium rounded-xl text-sm w-20 py-2.5 text-center ms-1"
                    onClick={changePageNext}
                    type="button"
                  >
                    {t('Next')}
                  </button>
                )}
              </div>
            </center>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdfViewerModal;
